import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'de', 'es', 'fr', 'sv', 'tr', 'pt', 'ca', 'it', 'ja', 'pl', 'cs', 'hu', 'ko', 'da', 'no', 'nb', 'fi', 'hr', 'nl'],
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    ns: ['chatbot'],
    defaultNS: 'chatbot',
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupFromPathIndex: 2, // /support/chatbot/{lang} -> lang is at index 2
    },
    backend: {
      loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`,
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
